import React from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import { DataCacheProvider } from './context/DataCacheContext';
import { GlobalDataProvider } from './context/GlobalDataContext';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <GlobalDataProvider>
      <DataCacheProvider>
        <div className="App">
          <LandingPage />
        </div>
        <Analytics />
      </DataCacheProvider>
    </GlobalDataProvider>
  );
}

export default App;
